<template>
    <table class="table">
        <thead>
        <tr>
            <td colspan="5" class="text-center">Summary of Hours {{month}} {{year}}
                Inspection
            </td>
        </tr>
        <tr>
            <td>Dispatched</td>
            <td>Not Dispatched</td>
            <td>Total Sched</td>
            <td>Matrix</td>
            <td>Variance</td>

        </tr>
        </thead>
        <tbody>
        <tr v-if="this.$store.getters['schedules/totalHours']">
            <td>{{ hours.dispatched }}</td>
            <td>{{ $store.getters['schedules/totalHours']  - (hours.dispatched || 0)}}</td>
            <td>{{ $store.getters['schedules/totalHours'] }}</td>
            <td>{{ hours.matrix_hours }}</td>
            <td>
                <span v-if="getVariance < 0" style="color:red">({{ Math.abs(getVariance) }})</span>
                <span v-else>({{ Math.abs(getVariance) }})</span>
            </td>
        </tr>
        </tbody>
    </table>

</template>
<script>

export default {
    name: "ScheduleMatrixHours",
    props: {
        scheduleId: {
            required: true
        },
        month: {},
        year: {}
    },
    data() {
        return {
            hours: {
                dispatched: 0,
                not_dispatched: 0,
                total_hours: 0,
                matrix_hours: 0,
                variance: 0,
            }
        }
    },
    computed: {
        getVariance(){
            return (this.hours.matrix_hours || 0) - this.$store.getters['schedules/totalHours']
        }
    },
    mounted() {
        this.getHours()
    },
    methods: {
        async getHours() {
            let response = await axios.get(`/schedules/${this.scheduleId}/hours-matrix`)
            this.hours = response.data;
        }
    }
}
</script>
<style scoped>
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
    padding: 2px 1px !important;
    vertical-align: middle;
}
</style>
